import React from 'react';
import { useLabels, usePrefs } from 'wsm-common-data';
import PropTypes from 'prop-types';
import ContactLinksList from './ContactLinksList';
import DepartmentHoursTabs from './DepartmentHoursTabs';
import AddressCard from './AddressCard';
import generateUID from '../../../util/modern/generateUID';

const RichContent = ({
	addInfo,
	richContentToDisplay,
	pageAlias,
	windowId,
	triggerTrackingEvent
}) => {
	const labels = useLabels();
	const {
		addressHeadingLabel,
		addressClasses,
		addressGetDirectionsLabel,
		hoursTabsHeaderLabel
	} = usePrefs();
	const labelSize = 3;

	// Generate unique ids
	const contactLinksAriaLabelledById = generateUID(
		`${pageAlias}_${windowId}`
	);
	const addressAriaLabelledById = generateUID(`${pageAlias}_${windowId}`);
	const hoursTabsAriaLabelledById = generateUID(`${pageAlias}_${windowId}`);
	const hoursTabsId = generateUID(`${pageAlias}_${windowId}`);

	// Contact Links
	const renderContactLinksList = () => {
		if (
			addInfo &&
			addInfo.phoneNumbers &&
			richContentToDisplay.some(
				(item) =>
					[
						'phone-sales',
						'phone-service',
						'phone-parts',
						'phone-commercial',
						'email'
					].indexOf(item) > -1
			)
		) {
			const { phoneNumbers, email = '' } = addInfo;
			return (
				<ContactLinksList
					phoneNumbers={phoneNumbers}
					email={email}
					richContentToDisplay={richContentToDisplay}
					labelSize={labelSize}
					ariaLabelledById={contactLinksAriaLabelledById}
					triggerTrackingEvent={triggerTrackingEvent}
				/>
			);
		}
		return null;
	};

	// Address
	const renderAddress = () => {
		const hideLabel = richContentToDisplay.some(
			(item) =>
				[
					'email',
					'phone-sales',
					'phone-service',
					'phone-parts',
					'phone-commercial'
				].indexOf(item) > -1
		);
		if (addInfo && richContentToDisplay.includes('address')) {
			const {
				dealerInfo: { name, address1, city, state, postalCode },
				mapLink
			} = addInfo;
			return (
				<AddressCard
					name={name}
					address1={address1}
					city={city}
					state={state}
					postalCode={postalCode}
					getDirectionsLabel={labels.get(addressGetDirectionsLabel)}
					getDirectionsUrl={mapLink}
					label={!hideLabel ? labels.get(addressHeadingLabel) : ''}
					labelSize={labelSize}
					ariaLabelledById={addressAriaLabelledById}
					addressClasses={addressClasses}
					triggerTrackingEvent={triggerTrackingEvent}
				/>
			);
		}
		return null;
	};

	// Hours
	const renderHours = () => {
		if (
			addInfo &&
			addInfo.hours &&
			richContentToDisplay.some(
				(item) =>
					[
						'hours-sales',
						'hours-service',
						'hours-parts',
						'hours-commercial'
					].indexOf(item) > -1
			)
		) {
			const { hours } = addInfo;
			const departments = richContentToDisplay
				.filter((richContentName) =>
					richContentName.startsWith('hours')
				)
				.map((richContentName) => richContentName.split('-')[1]);
			return (
				<DepartmentHoursTabs
					departments={departments}
					departmentHours={hours}
					label={labels.get(hoursTabsHeaderLabel)}
					labels={labels}
					labelSize={labelSize}
					ariaLabelledById={hoursTabsAriaLabelledById}
					triggerTrackingEvent={triggerTrackingEvent}
					tabId={hoursTabsId}
				/>
			);
		}
		return null;
	};

	return (
		<div>
			{renderContactLinksList()}
			{renderAddress()}
			{renderHours()}
		</div>
	);
};
RichContent.propTypes = {
	addInfo: PropTypes.shape(),
	richContentToDisplay: PropTypes.arrayOf(PropTypes.string),
	pageAlias: PropTypes.string,
	windowId: PropTypes.string,
	triggerTrackingEvent: PropTypes.func
};

export default RichContent;
